import { render, staticRenderFns } from "./ProfessionalReferenceLongForm.vue?vue&type=template&id=fc2abb38&"
import script from "./ProfessionalReferenceLongForm.vue?vue&type=script&lang=ts&"
export * from "./ProfessionalReferenceLongForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProfessionalReferenceLongForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports